var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeutralRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.721297 6.84233C0.770398 6.8503 0.820089 6.85397 0.869807 6.85333L9.33557 6.85333L9.15097 6.93919C8.97053 7.02459 8.80638 7.14082 8.66586 7.28263L6.29185 9.65664C5.97919 9.95511 5.92665 10.4352 6.16736 10.7943C6.4475 11.1769 6.98474 11.2599 7.36735 10.9798C7.39826 10.9571 7.42764 10.9325 7.45525 10.9059L11.7482 6.61292C12.0837 6.2778 12.084 5.73418 11.7489 5.39868C11.7487 5.39847 11.7484 5.39823 11.7482 5.39801L7.45525 1.10504C7.11948 0.77022 6.57586 0.77097 6.24101 1.10673C6.21466 1.13316 6.19005 1.16128 6.16736 1.1909C5.92665 1.54993 5.97919 2.03007 6.29185 2.32854L8.66157 4.70684C8.78754 4.83295 8.93238 4.93869 9.09087 5.02023L9.34845 5.13614L0.917056 5.13614C0.478449 5.11986 0.0936384 5.42624 0.01124 5.85736C-0.0646648 6.32543 0.25323 6.7664 0.721297 6.84233Z",
    fill: "#898989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 -1 12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralRightArrow);
export default __webpack_public_path__ + "static/media/neutral-right-arrow.20ee08571e837d60e056d959605c707e.svg";
export { ForwardRef as ReactComponent };